import { Component, OnInit } from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {SyslogApiService} from '../../../services/api/settings/network-services/syslog/syslog-api.service';
import {SyslogTypes} from '../../enums/settingsEnums';
import {TrueFalsePipe} from '../../../pipes/true-false/true-false.pipe';
import {AcDialogService, PromiseService} from 'ac-infra';
import {SyslogDialogComponent} from './syslog-dialog/syslog-dialog.component';

@Component({
  selector: 'syslog',
  templateUrl: './syslog.component.html',
  styleUrls: ['./syslog.component.scss']
})
export class SyslogComponent implements OnInit {

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'enabled', display: 'Enabled', selected: true, width: 100, transformer: TrueFalsePipe },
    {name: 'sourceType', display: 'Source Type', selected: true, width: 180},
    {name: 'host', display: 'Host', selected: true, width: 200},
    {name: 'port', display: 'Port', selected: true, width: 100},
    {name: 'protocol', display: 'Protocol', selected: true, width: 100},
    {name: 'level', display: 'Log Level', selected: true, width: 100},
  ];
  items;
  isMultipleSelection: false;
  selection;
  isUnauthorized: boolean;

  constructor(private userPrivilege: UserPrivilegeService,
              private sysLogApiService: SyslogApiService, private dialogService: AcDialogService  ) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  editItem(): void {
    const syslogId = this.selection.id;

    this.sysLogApiService.getSyslog(syslogId).subscribe(syslog => {
      this.openSyslogDetailsDialog(syslog);
    });
  }

  pageChanged($event: PageEvent) {

  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  refresh(): void {
    this.sysLogApiService.getSyslogs().subscribe(data => {
      this.items = data.filter((syslog) => syslog.sourceType !== SyslogTypes.CDR);
    });
  }

  private openSyslogDetailsDialog(syslog: any): void {
    const myData = {
      syslog
    };

    this.dialogService.open(SyslogDialogComponent, {
      dialogData: myData,
      title: 'Edit Syslog',
      onSubmit: () => {
        return   this.sysLogApiService.editSyslog(myData.syslog, myData.syslog.id).toPromise().then(() => {
          this.refresh();
        });

       },
    });

  }

}
